import FaqCtrl from '../controllers/FaqCtrl';
import cssUtil from 'gw-portals-util-js/CssUtil';

import FaqTemplate from 'text!./FaqDirective.html';
import styles from 'edge/faq/directives/FaqDirective-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(FaqTemplate, styles);

export default (function () {
    return {
        restrict: 'E',
        template: hashedTemplate,
        controller: FaqCtrl
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/faq/directives/FaqDirective.js
// module id = 950
// module chunks = 0